<!--suppress ALL -->
<!--suppress UnreachableCodeJS -->
<template>
	<page>
		<v-row
			align-content="center"
			justify="center"
		>
			<v-col cols="8">
				<base-material-card>
					<template #heading>
						<div class="d-flex">
							<div class="text-h3 font-weight-light">
								יצירת מסלול לפרויקט "{{ project.subject }}"
							</div>
						</div>
					</template>
					<form @submit.prevent="onSubmit">
						<smart-input
							v-model="form.title"
							:error="errors.title"
							label="שם תכנית"
						/>
						<smart-input
							v-model="form.description"
							:error="errors.description"
							label="תיאור תכנית"
						/>
						<smart-input
							v-model="form.additional"
							type="json"
							:error="errors.additional"
							label="Metadata(JSON only)"
							style="direction: ltr"
						/>
						<plans-select v-model="form.type"/>
						<smart-input
							v-model="form.amount"
							:error="errors.amount"
							label="כמות"
							type="number"
						/>
						<smart-input
							v-model="form.price"
							:error="errors.price"
							type="number"
							:label="form.custom_price ? 'מחיר מינימום':'מחיר'"
						/>
						<v-select
							v-model="form.currency"
							:error="errors.currency"
							type="number"
							required
							label="מטבע"
							:items="[
								{
									text: 'שקל ישראלי',
									value: 'ILS'
								},
								{
									text: 'דולר אמרקאי',
									value: 'USD'
								}
							]"
						/>
						<smart-input
							v-model="form.custom_price"
							:error="errors.custom_price"
							type="checkbox"
							label="מחיר לפי בחירה"
						/>
						<smart-input
							v-model="form.additional_text"
							row="3"
							:error="errors.additional_text"
							label="טקסט נוסף מתחת לתיאור - יופיע בשלב התשלום"
						/>
						<v-btn
							type="submit"
							:loading="inProgress"
							color="success"
						>
							שמירה
						</v-btn>
					</form>
				</base-material-card>
			</v-col>
		</v-row>
	</page>
</template>

<script>
import FormView from "src/mixins/FormView";
import ProjectModule from "@/store/modules/Project.module";
import PlanModule from "@/store/modules/Plan.module";
import PlansSelect from "@/components/PlansSelect";

export default {
	name: "PlanForm",
	components: {PlansSelect},
	mixins: [new FormView(PlanModule, "plan")],
	data() {
		return {
			form: {},
			errors: {},
			inProgress: false,
			projectId: this.$route.params.projectId,
			planId: this.$route.params.planId,
		};
	},
	computed: {
		project() {
			return this.$store.state.ProjectModule.project;
		},
		plan() {
			return this.$store.state.PlanModule.plan;
		},

	},
	async created() {
		if (this.planId) {
			await this.$store.dispatch(PlanModule.types.GET, this.planId);
			Object.assign(this.form, this.plan);
			this.projectId = this.plan.project_id;
			this.$store.dispatch(ProjectModule.types.GET, this.projectId);
		} else {
			this.projectId = this.$route.params.projectId;
			this.$store.dispatch(ProjectModule.types.GET, this.projectId);
			this.$store.commit(PlanModule.types.CREATE);
		}
	},
	methods: {
		updatePlan(planType) {
			this.form.type = planType;
		},
		beforeSubmit() {
			this.form.project_id = this.projectId;
		},
		onSuccess() {
			this.$router.push({
				name: "project-view",
				params: {id: this.projectId},
			});
			this.$notfication.success();
		},
	},

};
</script>
